import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { TableComponent } from '../../../../shared/ui/table/table.component';
import {
  EFilterType,
  ITableColumn,
  ITableFilter,
} from '../../../../store/models/table.model';
import { IContactItem } from '../../../../store/models/contact.model';
import { ApiDataSource } from '../../../../datasources/api.datasrouce';
import { IUserSessionData } from '../../../../store/models/user.model';
import { AccountService } from '../../../../store/services/account.service';
import { environment } from '../../../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { takeUntil } from 'rxjs/operators';
import { SessionService } from '../../../../store/services/session.service';
import { Subject } from 'rxjs';
import { IStepValidation, WizardStep } from '../../WizardStep';
import { ContactStatusSelectionStepComponent } from '../contact-status-selection-step/contact-status-selection-step.component';
import { WizardService } from '../../wizard.service';
import { SelectionChange } from '@angular/cdk/collections';
import { WIZARD_COMPONENT, WizardComponent } from '../../wizard.component';

@Component({
  selector: 'app-contact-contact-selection-step',
  templateUrl: './contact-contact-selection-step.component.html',
  styleUrls: ['./contact-contact-selection-step.component.scss'],
})
export class ContactContactSelectionStepComponent
  implements OnInit, WizardStep
{
  static STEP_NAME = 'select-contacts';

  constructor(
    private accountService: AccountService,
    private http: HttpClient,
    private sessionService: SessionService,
    private readonly wizardService: WizardService,
    @Inject(WIZARD_COMPONENT) private readonly wizardComponent: WizardComponent
  ) {}

  @ViewChild('tableComponent') tableComponent: TableComponent;

  tableColumns: ITableColumn<IContactItem>[];

  dataSource: ApiDataSource<IContactItem>;

  tableDataSourceParams;

  tableReady: boolean;

  tagsFilter = [];

  tableFilters: ITableFilter[] = [];

  sessionData: IUserSessionData;

  groupIds: number[];

  wizardData: any;

  preselectedContactIds: IContactItem[];

  private destroy$: Subject<boolean> = new Subject<boolean>();

  private selectedContacts: IContactItem[];

  private static setTableColumns(): ITableColumn<IContactItem>[] {
    return [
      {
        id: 'contact_firstname',
        title: 'Name',
        sortable: true,
        renderer: (element: IContactItem) => {
          return `${element.contact_firstname || ''} ${
            element.contact_lastname || ''
          }`;
        },
      },
      {
        id: 'contact_company',
        title: 'Company',
        sortable: true,
      },
      {
        id: 'contact_email',
        title: 'Email Address',
        sortable: true,
      },
    ];
  }

  private static mapStatuses(statuses: string[]) {
    return statuses.map(status => {
      switch (status) {
        case 'Active':
        case 'Meeting':
        case 'Inactive':
        case 'Cycle':
          return status.toLowerCase();
        case 'Follow Up':
          return 'followup';
      }
    });
  }

  getSelectedStatuses() {
    if (this.wizardData[ContactStatusSelectionStepComponent.STEP_NAME]) {
      return ContactContactSelectionStepComponent.mapStatuses(
        this.wizardData[ContactStatusSelectionStepComponent.STEP_NAME]
      );
    }

    return [];
  }

  ngOnInit() {
    this.wizardService.disableNextButton();
    if (this.wizardData[ContactContactSelectionStepComponent.STEP_NAME]) {
      this.preselectedContactIds =
        this.wizardData[ContactContactSelectionStepComponent.STEP_NAME];
    }

    this.tableDataSourceParams = {
      page: 1,
      pageSize: 10,
      filters: {
        group_id: this.groupIds.join(','),
        contact_status: this.getSelectedStatuses().join(','),
      },
    };

    this.accountService.getTags().subscribe(response => {
      const data = {
        label: 'Tags',
        type: EFilterType.MULTISELECT,
        items: [],
        onFilterChange: value => this.tagChange(value),
      };
      response.items.forEach(item =>
        data.items.push({
          id: item.id,
          label: item.name,
          value: item.name,
        })
      );
      this.tableFilters.push(data);
    });

    this.dataSource = new ApiDataSource<IContactItem>(
      this.http,
      environment.apiUrl + `/v1/contacts`
    );

    this.sessionService
      .onReady()
      .pipe(takeUntil(this.destroy$))
      .subscribe((sessionData: IUserSessionData) => {
        this.sessionData = sessionData;
        this.tableColumns =
          ContactContactSelectionStepComponent.setTableColumns();
        this.tableReady = true;
      });
  }

  tagChange(value) {
    this.tagsFilter = value;
    this.tableReady = false;
    this.tableDataSourceParams.filters.tags = this.tagsFilter.toString();
    this.tableReady = true;
  }

  provideData(): any {
    return this.selectedContacts;
  }

  async validate(): Promise<IStepValidation> {
    let success = true;
    const errors = [];

    if (!this.selectedContacts || !this.selectedContacts.length) {
      success = false;
      errors.push('Please, select at least 1 contact');
    }

    return {
      success,
      errors,
    };
  }

  onRowSelected($event: SelectionChange<IContactItem>) {
    this.wizardService.setNextButtonState($event.source.selected.length > 0);
    this.selectedContacts = $event.source.selected;
  }
}
